import React from 'react';

const Bulgaria = (props) => (
  <svg width="28" height="20" viewBox="0 0 28 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3127_46667)">
      <path
        d="M25.3333 0H2.66667C1.19391 0 0 1.19391 0 2.66667V17.3333C0 18.8061 1.19391 20 2.66667 20H25.3333C26.8061 20 28 18.8061 28 17.3333V2.66667C28 1.19391 26.8061 0 25.3333 0Z"
        fill="#249F58"
      />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 13.3335H28V20.0002H0V13.3335Z" fill="#F93939" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0 0H28V6.66667H0V0Z" fill="white" />
    </g>
    <rect x="0.25" y="0.25" width="27.5" height="19.5" rx="2.75" stroke="#AEAEAE" strokeWidth="0.5" />
    <defs>
      <clipPath id="clip0_3127_46667">
        <rect width="28" height="20" rx="3" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Bulgaria;
